<div class="filters" *ngIf="!hideFilters">
  <form [formGroup]="form">
    <div class="searchbar">
      <markant-input label="Suche" class="search" type="text" ngDefaultControl placeholder="nach Start-up suchen" formControlName="text">
        <markant-icon slot="markant-icon-leading" src="./assets/svg/m_search.svg" height="auto"></markant-icon>
      </markant-input>
    </div>
    <div class="filterbar">
      <div class="select-large" [ngClass]="!fixCycle ? 'd-block' : 'd-none'">
        <markant-select ngDefaultControl formControlName="cycleFilter" label="Pitch">
          <markant-select-option value="all"><em>(alle)</em></markant-select-option>
          <markant-select-option value="none" *ngIf="!fixSingleCycle"><em>(ohne Zuordnung)</em> </markant-select-option>
          <markant-select-option *ngFor="let c of cycles$ | async" [value]="c.uuid">{{ c.name }}</markant-select-option>
        </markant-select>
      </div>

      <div class="select-large" *ngIf="!fixAnyWarenbereich">
        <app-product-group-select [allowEmpty]="true" [availableOnly]="true" formControlName="productGroupKey"></app-product-group-select>
      </div>

      <div class="select-large" [ngClass]="!fixStatusIn ? 'd-block' : 'd-none'">
        <markant-select label="Status" ngDefaultControl formControlName="statusIn">
          <markant-select-option value="all"><em>(alle)</em></markant-select-option>
          <markant-select-option value="created">angelegt</markant-select-option>
          <markant-select-option value="requested">angefordert</markant-select-option>
          <markant-select-option value="denied">abgelehnt</markant-select-option>
          <markant-select-option value="approved">bestätigt</markant-select-option>
          <markant-select-option value="invited">eingeladen</markant-select-option>
          <markant-select-option value="notinvited">nicht eingeladen</markant-select-option>
        </markant-select>
      </div>
      <div class="select-flex">
        <markant-select label="Favorit" ngDefaultControl formControlName="favorite">
          <markant-select-option value="all"><em>(alle)</em></markant-select-option>
          <markant-select-option value="true">Ja</markant-select-option>
          <markant-select-option value="false">Nein</markant-select-option>
        </markant-select>
      </div>

      <div class="select-large" [ngClass]="!fixAnyVerdict ? 'd-block' : 'd-none'">
        <markant-select label="meine Stimmen" ngDefaultControl formControlName="verdictFilter">
          <markant-select-option value="all"><em>(alle)</em></markant-select-option>
          <markant-select-option value="up">Stimme abgegeben</markant-select-option>
          <markant-select-option value="noverdict"><em>(keine Stimme)</em></markant-select-option>
        </markant-select>
      </div>

      <div class="select-large">
        <markant-select label="Sortierung" formControlName="searchProductSort" ngDefaultControl>
          <markant-select-option *ngIf="isMa" value="votesDesc">Abstimmungsergebnis</markant-select-option>
          <markant-select-option value="productCreatedDesc">Neuste zuerst</markant-select-option>
          <markant-select-option value="productNameAsc">Produktname</markant-select-option>
          <markant-select-option value="startupNameAsc">Start-up-Name</markant-select-option>
        </markant-select>
      </div>

      <div class="actionsTemplate">
        <ng-container *ngTemplateOutlet="actionsTemplate"></ng-container>
      </div>
    </div>
    <div class="actionbuttons-group">
      <ng-container *ngIf="excelExportEnabled">
        <div class="export" *ngIf="query$ | async as q">
          <markant-button type="button" class="black button" (click)="businessRelationExport(q)">
            <em class="far fa-file-excel"></em>
            GB-Status
          </markant-button>
        </div>
      </ng-container>

      <ng-container *ngIf="excelExportEnabled && !hideBrExport">
        <div class="export" *ngIf="query$ | async as q">
          <markant-button type="button" class="black button" (click)="excelExport(q)">
            <i class="far fa-file-excel"></i>
            Liste
          </markant-button>
        </div>
      </ng-container>
    </div>
  </form>
</div>
<div class="product-list">
  <app-continuous-action #loading></app-continuous-action>
  <ng-container *ngIf="query$ | async as query">
    <div class="product-grid" *ngIf="response$ | async as response">
      <app-product-entry
        *ngFor="let productEntry of response.results; let i = index"
        class="product-grid__item"
        [entry]="productEntry"
        [query]="query"
        [index]="i"
        [entryWidget]="entryWidget"
      ></app-product-entry>
    </div>
  </ng-container>
  <div [ngClass]="!hidePagination ? 'd-block' : 'd-none'">
    <mat-paginator #paginator [length]="(response$ | async)?.total" [pageSize]="fixPageSize || 60" [pageSizeOptions]="[12, 60, 144]"> </mat-paginator>
  </div>
</div>
